/** @ngInject */
export default function config($stateProvider) {
	$stateProvider.state('app.logout', {
		url: '/logout',
		component: 'logoutIndexState',
	})
}
